// analytics.js
export const trackEvent = (action, params = {}) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, params);
  } else {
    console.log("Analytics (mock):", action, params);
  }
};

export const trackPageView = (pagePath, pageTitle = document.title) => {
  trackEvent("page_view", {
    page_path: pagePath,
    page_title: pageTitle,
  });
};
